import { Injectable, signal } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { UserJsVm } from '../generated/Administration/Models/User/JavaScript/UserJsVm';

@Injectable({
    providedIn: 'root'
})
export class GlobalService {

    isNavFixed: BehaviorSubject<boolean> = new BehaviorSubject(false); // Should convert to signal
	isNavOpen = signal<boolean>(null!);

    public scrollPositionOfSubNav: number;
    public static currentEventName: string;
    public static currentEventProductNameReportText: string;
    public static onHandText: string;

    constructor() { this.scrollPositionOfSubNav = 0; }

    public setNavPosition(val: number) { this.scrollPositionOfSubNav = val; }  

    public getNavPosition() { return this.scrollPositionOfSubNav; }

    static setIsMobile(getScreenWidth: any) {
		if (getScreenWidth < 993) { return true; }
		else { return false; }
	}

    public static eventize(user: UserJsVm) {
        this.currentEventName = user.currentEventName!;
        this.currentEventProductNameReportText = user.currentEventProductNameReportText!;
        this.onHandText = user.currentEventProductCountReportText!;
    }
}